import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { catchError, finalize, Observable, throwError } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ApiService {

    constructor(private http: HttpClient) { }

    private handleServerError(err: HttpErrorResponse) {

        if (!err.ok) {
            let errdescription = err.message;

            if (err.status == 404) {
                if (err.error && err.error.title)
                    errdescription = err.error.title;
            }
        }

        return throwError(() => err);
    }

    get(path: string): Observable<any> {
        const httpOptions = {
            headers: new HttpHeaders({
                'Access-Control-Allow-Origin': '*'
            }),
        };

        return this.http
            .get(`${environment.appApiURL}${path}`, httpOptions)
            .pipe(
                catchError((err: HttpErrorResponse) => {
                    return this.handleServerError(err);
                }),
                finalize(() => {
                })
            );
    }

    getBlob(path: string): Observable<Blob> {
        const httpOptions = {
            headers: new HttpHeaders({
                'Access-Control-Allow-Origin': '*'
            }),
            responseType: 'blob' as 'json'
        };

        return this.http
            .get(`${environment.appApiURL}${path}`, { ...httpOptions, responseType: 'blob' })
            .pipe(
                catchError((err: HttpErrorResponse) => {
                    return this.handleServerError(err);
                }),
                finalize(() => {
                })
            ) as Observable<Blob>;
    }

    post(path: string, body: object | FormData = {}): Observable<any> {

        // FormData (multipart uploads) must NOT be JSON-stringified or given an explicit
        // Content-Type - the browser needs to set its own boundary in the header.
        if (body instanceof FormData) {
            const formOptions = {
                headers: new HttpHeaders({
                    'Access-Control-Allow-Origin': '*'
                }),
            };

            return this.http
                .post(
                    `${environment.appApiURL}${path}`,
                    body,
                    formOptions
                )
                .pipe(
                    catchError((err: HttpErrorResponse) => {
                        return this.handleServerError(err);
                    }),
                    finalize(() => {
                    })
                );
        }

        var jsonOptions = {
            headers: new HttpHeaders({
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json'
            }),
        };

        return this.http
            .post(
                `${environment.appApiURL}${path}`,
                JSON.stringify(body),
                jsonOptions
            )
            .pipe(
                catchError((err: HttpErrorResponse) => {
                    return this.handleServerError(err);
                }),
                finalize(() => {
                })
            );
    }

    postFile(path: string, file: File): Observable<any> {
        const formData = new FormData();
        formData.append('file', file);

        return this.http
            .post(
                `${environment.appApiURL}${path}`,
                formData
            )
            .pipe(
                catchError((err: HttpErrorResponse) => {
                    return this.handleServerError(err);
                }),
                finalize(() => {
                })
            );
    }                               

    put(path: string, body: any = {}): Observable<any> {

        var jsonOptions = {
            headers: new HttpHeaders({
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json'
            }),
        };
        return this.http
            .put(
                `${environment.appApiURL}${path}`,
                JSON.stringify(body),
                jsonOptions
            )
            .pipe(
                catchError((err: HttpErrorResponse) => {
                    return this.handleServerError(err);
                }),
                finalize(() => {
                })
            );
    }

    delete(path: string): Observable<any> {
        const httpOptions = {
            headers: new HttpHeaders({
                'Access-Control-Allow-Origin': '*'
            }),
        };

        return this.http
            .delete(`${environment.appApiURL}${path}`, httpOptions)
            .pipe(
                catchError((err: HttpErrorResponse) => {
                    return this.handleServerError(err);
                }),
                finalize(() => {
                })
            );
    }
}


